import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
// import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import { Button } from 'semantic-ui-react';

// import { getVocabulary } from '@plone/volto/actions/vocabularies/vocabularies';
import { getVocabulary } from '../../../actions/vocabularies/vocabularies';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import Icon from '@plone/volto/components/theme/Icon/Icon';

import { addLocation } from '../../../actions';
import { STATUS_VOCABULARY_ID } from '../../../constants';
import arrowRight from '../../../theme/icons/arrow-right.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';

import PropTypes from 'prop-types';

export const ActionComponent = ({
  content,
  locations,
  pathname,
  isLoggedIn,
  isManager,
  intl,
  dispatch,
}) => {
  const statuses = useSelector(
    (state) => state.vocabularies?.[STATUS_VOCABULARY_ID],
  );
  const { locale } = useSelector((state) => state.intl);

  useEffect(() => {
    dispatch(getVocabulary({ vocabNameOrURL: STATUS_VOCABULARY_ID, locale }));
  }, [dispatch, locale]);

  return (
    <>
      {!isLoggedIn ? (
        <div className="location-action-wrapper primary-color">
          <FormattedMessage
            id="Register label message"
            defaultMessage="Si estás interesado en rodar en el País Vasco, crea una cuenta gratuita para acceder a nuestra área privada de localizaciones."
          />
          <UniversalLink href={`/${intl.locale}/login?return_url=${pathname}`}>
            <Button className="primary">
              <FormattedMessage
                id="Register or log in to get more info"
                defaultMessage="Register or log in to get more info"
              />
              <Icon
                className="arrow svg-inline--fa"
                name={arrowRight}
                title="arrow"
              />
            </Button>
          </UniversalLink>
        </div>
      ) : !isManager &&
        isLoggedIn &&
        !locations.find((loc) => loc?.location?.['@id'] === content['@id']) ? (
        <div className="location-action-wrapper primary-color">
          <FormattedMessage
            id="Add to my locations label message"
            defaultMessage="Si estás interesado en rodar en el País Vasco, crea una cuenta gratuita para acceder a nuestra área privada de localizaciones."
          />
          <Button
            className="primary"
            onClick={() => {
              dispatch(addLocation(pathname));
            }}
          >
            <FormattedMessage
              id="Add to my locations"
              defaultMessage="Add to my locations"
            />
            <FontAwesomeIcon icon={faBookmark} className="icon" />
          </Button>
        </div>
      ) : !isManager &&
        isLoggedIn &&
        locations.find(
          (loc) =>
            loc?.location?.['@id'] === content['@id'] &&
            statuses.loaded &&
            statuses.items?.find((status) => status?.value === '1')?.value ===
              loc.status,
        ) ? (
        <div className="location-action-wrapper pending-color">
          <strong>
            <FormattedMessage
              id="Pending for review"
              defaultMessage="Pending for review"
            />
          </strong>
          <FormattedMessage
            id="Pending for review label message"
            defaultMessage="La información solicitada tiene que ser adminitada por el administrador del sitio. Recibiras un email cuando tengas permiso."
          />
          <UniversalLink href={`/${intl.locale}/private-area`}>
            <Button className="pending">
              <FormattedMessage
                id="Visit your location statuses"
                defaultMessage="Visit your location statuses"
              />
              <Icon
                className="arrow svg-inline--fa"
                name={arrowRight}
                title="arrow"
              />
            </Button>
          </UniversalLink>
        </div>
      ) : (
        !isManager &&
        isLoggedIn &&
        locations.find(
          (loc) =>
            loc?.location?.['@id'] === content['@id'] &&
            statuses.loaded &&
            statuses.items?.find((status) => status?.value === '3')?.value ===
              loc.status,
        ) && (
          <div className="location-action-wrapper rejected-color">
            <FormattedMessage
              id="Rejected"
              defaultMessage="Su solicitud ha sido rechazada"
            />
          </div>
        )
      )}
    </>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ActionComponent.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    for_member: PropTypes.string,
    for_authorized_members: PropTypes.string,
    for_requested_members: PropTypes.string,
  }).isRequired,
  locations: PropTypes.array,
  pathname: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  isManager: PropTypes.bool,
};
